import axios from "axios";
//const API_URL_Domain = "http://172.27.181.168:8080/api/v1/";
const API_URL_Domain = "https://amethyst.gistda.or.th/api/v1/";
const API_URL_DomainV2 = "https://amethyst.gistda.or.th/api/v2/";
const API_URL_Local = "http://172.27.181.225:8100/api/v2/";
//const API_URL_Domain_Domain = process.env.REACT_SECRET_API+"/api/v1/"

const register = (
  email,
  firstName,
  lastName,
  idnum,
  phone,
  password,
  password_confirmation
) => {
  return axios
    .post(API_URL_Local + "register", {
      email,
      firstName,
      lastName,
      idnum,
      phone,
      password,
      password_confirmation,
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};
const login_token = () => {
  const token = sessionStorage.getItem("access_token");
  return axios
    .get(API_URL_Local + "user/userid", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      if (response.data.user_id) {
        sessionStorage.setItem("user", JSON.stringify(response.data.user_id));
      }
      //console.log(response);
      return response.data;
    });
};
/*const test = () => {
  const token = sessionStorage.getItem("access_token");
  return axios
    .get(API_URL_Local + "user/userid", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      console.log(response);
      return response.data;
    });
};*/
const login = (username, password) => {
  return axios
    .post(API_URL_Local + "login", {
      username,
      password,
      //headers:{ Authorization: `Bearer ${token}`}
    })
    .then((response) => {
      console.log(response);
      //response.preventdefault()
      if (response.data.token.access_token) {
        sessionStorage.setItem(
          "access_token",
          response.data.token.access_token
        );
        sessionStorage.setItem(
          "refresh_token",
          response.data.token.refresh_token
        );
        // sessionStorage.setItem("user", JSON.stringify(response.data.user_id));
        sessionStorage.setItem(
          "type_user",
          JSON.stringify(response.data.user_type)
        );
        sessionStorage.setItem(
          "pilot_id",
          response.data.all_id.pilot_id
        );
        sessionStorage.setItem(
          "pilot_code_open",
          response.data.all_id.pilot_code_open
        );
        sessionStorage.setItem(
          "pilot_code_specific",
          response.data.all_id.pilot_code_specific
        );
        sessionStorage.setItem(
          "operator_id",
          response.data.all_id.operator_id
        );
        sessionStorage.setItem(
          "operator_code",
          response.data.all_id.operator_code
        );
      }
      //const data = JSON.parse(sessionStorage.getItem("user"));
      // console.log(data);
      //control(data)
      //getCurrentUser()
      return response;
    })
    .catch((error) => {
      return error.response.data.error_description;
    });
};

const logout = () => {
  sessionStorage.removeItem("user");
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "logout",
      {
        userid: data,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      return response.data;
    });
};

const getCurrentUser = () => {
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "user/getuserdata",
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      //console.log(response);
      return response;
    })
    .catch((error) => {
      console.log("Something went wrong due to \n" + error);
    });
  //JSON.parse(sessionStorage.getItem("user"));
};
const getMoniterDrone = (timestart, timeend) => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");

  return axios
    .post(
      API_URL_Local + "monitor/flight-history",
      {
        userid: data,
        operation_id: 1,
        timestart: timestart, //"1671695605770",
        timeend: timeend, //"2671695614804"
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      console.log(response);
      return response.data;
    });
  //JSON.parse(sessionStorage.getItem("user"));
};
const getDronedata = (droneid, type) => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "drone/dronedata",
      {
        userid: data,
        //method: "GDD",
        droneid,
        type,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      //console.log(response);
      return response.data;
    });
  //JSON.parse(sessionStorage.getItem("user"));
};
const getDronedatadoc = (droneid) => {
  console.log(droneid);
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "drone/dronedatadoc",
      {
        userid: data,
        //method: "GDD",
        droneid,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      //console.log(response);
      return response.data;
    });
  //JSON.parse(sessionStorage.getItem("user"));
};
const getpurposeandfq = (droneid) => {
  console.log(droneid);
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "operation/freq-pur-list",
      {
        userid: data,
        droneid: droneid,
        //method: "GDD",
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      //console.log(response);
      return response.data;
    });
  //JSON.parse(sessionStorage.getItem("user"));
};
const getDronelist = (type) => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "drone/droneuserlist",
      {
        userid: data,
        method: "GDL",
        type,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      //console.log(response);
      return response;
    });
  //JSON.parse(sessionStorage.getItem("user"));
};
const connectRemote_id = (droneid, remoteidsn) => {
  //แก้อันนี้
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "drone/connectrid",
      {
        userid: data,
        method: "DCR",
        droneid,
        remoteidsn,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      //console.log(response);
      return response;
    });
  //JSON.parse(sessionStorage.getItem("user"));
};

const registeroperation = () => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const access_token = sessionStorage.getItem("access_token");
  const refresh_token = sessionStorage.getItem("refresh_token");

  return axios
    .post(
      API_URL_Local + "operator/regisoperator",
      {
        userid: data,
      },
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          refresh_token: `Bearer ${refresh_token}`,
        },
      }
    )
    .then((response) => {
      sessionStorage.setItem(
        "access_token",
        response.data.new_token.access_token
      );
      sessionStorage.setItem(
        "refresh_token",
        response.data.new_token.refresh_token
      );
      console.log(response);
    });
};
const createoperation = (
  droneid,
  purpose,
  operationStart,
  operationEnd,
  flight_data,
  altitude,
  area_type
) => {
  console.log(
    droneid,
    purpose,
    operationStart,
    operationEnd,
    flight_data,
    altitude,
    area_type
  );
  const data = JSON.parse(sessionStorage.getItem("user"));
  const access_token = sessionStorage.getItem("access_token");
  console.log(operationStart);
  return axios
    .post(
      API_URL_Local + "operation/insert-area",
      {
        userid: data,
        droneid: droneid,
        purpose: purpose,
        operationStart,
        operationEnd,
        flight_data,
        altitude,
        area_type,
      },
      { headers: { Authorization: `Bearer ${access_token}` } }
    )
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((error) => {
      console.log(error);
    });
};
const createoperationagency = (
  purpose,
  //frequency,
  operationStart,
  operationEnd,
  flight_data,
  altitude,
  area_type
) => {
  console.log(
    purpose,
    operationStart,
    operationEnd,
    flight_data,
    altitude,
    area_type
  );
  const data = JSON.parse(sessionStorage.getItem("user"));
  const access_token = sessionStorage.getItem("access_token");
  console.log(typeof 20);
  return axios
    .post(
      API_URL_Local + "operation/insert-area",
      {
        userid: data,
        purpose,
        //frequency,
        operationStart,
        operationEnd,
        flight_data,
        altitude,
        area_type,
      },
      { headers: { Authorization: `Bearer ${access_token}` } }
    )
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((error) => {
      console.log(error);
    });
};
const getalloperationdata = () => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const access_token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "operation/alldata",
      {
        userid: data,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    )
    .then((response) => {
      //console.log(response);
      return response;
    }).catch((err) => {
      console.log(err.response.data.error_description);
     
    });
};

const getalloperationdatamap = (formattedStartDate, formattedEndDate) => {
  console.log(formattedStartDate, formattedEndDate);
  const data = JSON.parse(sessionStorage.getItem("user"));
  const access_token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "operation/alldatamap",
      {
        userid: data,
        start_time: formattedStartDate,
        end_time: formattedEndDate,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    )
    .then((response) => {
      //console.log(response)
      return response;
    }).catch((err) => {
      console.log(err.response.data.error_description);
      
    });
};
const getoperationdata = (operationid, operation_userid) => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const access_token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "operation/data",
      {
        userid: data,
        operationid: operationid,
        operation_userid: operation_userid,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    )
    .then((response) => {
      console.log(response);
      return response;
    }).catch((err) => {
      console.log(err.response.data.error_description);
     
    });
};
const updateoperationstatus = (id, status) => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const access_token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "operation/update",
      {
        userid: data,
        operationid: id,
        status: status,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    )
    .then((response) => {
      console.log(response);
      return response;
    });
};
const getalldrone = () => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "drone/droneuser",
      {
        userid: data,
        method: "DAU",
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    });
};
const getdronerequser = (dronereqid) => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "drone/dronereqdata",
      {
        userid: data,
        method: "DRU",
        dronereqid,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    });
};

const edituserdata = (
  title,
  firstname,
  lastname,
  date_of_birth,
  age,
  nationality,
  address,
  dis,
  sub_dis,
  province,
  pos_code,
  cur_address,
  cur_dis,
  cur_sub_dis,
  cur_province,
  cur_poscode,
  occupation
) => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .put(
      API_URL_Local + "user/edituserdata",
      {
        userid: data,
        method: "EUD",
        title,
        firstname,
        lastname,
        date_of_birth,
        age,
        nationality,
        address,
        dis,
        sub_dis,
        province,
        pos_code,
        cur_address,
        cur_dis,
        cur_sub_dis,
        cur_province,
        cur_poscode,
        occupation,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    });
};
//////////////////////////////////////////////////// regulator
const droneuserlist = () => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "drone/droneuserlist",
      {
        userid: data,
        type: 4,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    }).catch((err) => {
      console.log(err);
     
    });
};
const updatedroneregis = (droneid) => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "drone/updatedroneregis",
      {
        userid: data,
        droneid,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    });
};
const findoperation = (operation_code, operation_id) => {
  console.log(operation_code);
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "operation/find",
      {
        operation_code,
        operation_id,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    });
};
const operationco = (operation_code, operation_id, droneid) => {
  console.log(operation_code);
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "operation/operation-co",
      {
        userid: data,
        operation_code,
        operation_id,
        droneid,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    });
};
const dronedataco = (drone_list, operationid) => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "operation/dronedata-co",
      {
        drone_list,
        operationid,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    });
};
const updateco = (uidupdate, droneid, operationid) => {
  console.log(uidupdate, droneid, operationid);
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "operation/update-co",
      {
        userid: uidupdate,
        droneid: droneid[0],
        operationid,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    });
};
const checkoperator = () => {
  const data = JSON.parse(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("access_token");
  return axios
    .post(
      API_URL_Local + "operation/checkoperator",
      {
        userid: data,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response;
    });
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,

  registeroperation,
  edituserdata,
  getalldrone,
  getdronerequser,
  getMoniterDrone,
  getDronedata,
  getDronelist,
  connectRemote_id,
  login_token,
  createoperation,
  getalloperationdata,
  getoperationdata,
  updateoperationstatus,
  getalloperationdatamap,
  droneuserlist,
  updatedroneregis,
  createoperationagency,
  dronedataco,
  updateco,
  operationco,
  getpurposeandfq,
  getDronedatadoc,
  findoperation,
  checkoperator,
};

export default AuthService;
